import parse from "html-react-parser";
import { ICartAppointmentCommentsResponseData } from "@/api_framework/api_modals/Cart";
import PersonaDiscountComments from "@/app/components/ui/PersonaDiscountComments";
import { useFeatureAccess } from "@/app/hooks/useFeatureAccess";

interface CartCommentsCardProps {
  comments: ICartAppointmentCommentsResponseData[];
  personaDiscountComments?: string[];
  veticDateFormat: (date: string) => string;
}

const CartCommentsCard = ({ comments, personaDiscountComments = [], veticDateFormat }: CartCommentsCardProps) => {
  // RBAC: PERSONA_DISCOUNT_COMMENTS_VIEW — controls visibility of the persona discount callout
  const canViewPersonaDiscountComments = useFeatureAccess("PERSONA_DISCOUNT_COMMENTS_VIEW");

  return (
    <div>
      {canViewPersonaDiscountComments && personaDiscountComments?.length > 0 && (
        <PersonaDiscountComments comments={personaDiscountComments} />
      )}
      {comments[0] && comments.length > 0 ? (
        comments?.map(
          (cmt, index) =>
            cmt?.appointment_note && (
              <div key={index} className="border-[#ececec] my-1.5 p-2 border rounded-xl">
                <div className="flex justify-between items-center mb-2">
                  {<p className="font-medium text-xs">{cmt?.pet_name}</p>}
                  <p className="text-xs">
                    {veticDateFormat(cmt?.booking_date)} {""} {cmt?.booking_time}
                  </p>
                </div>
                <ul className="space-y-1 pl-3 list-disc">
                  {cmt?.appointment_note ? (
                    <div className="font-medium text-[#475467] text-xs">
                      {parse(
                        cmt.appointment_note
                          .replace(/<ol>/g, '<ul class="pl-5 list-disc">')
                          .replace(/<ul class="pl-5 list-disc"><ul class="pl-5 list-disc">/g, '<ul class="pl-5 list-disc">'),
                      )}
                    </div>
                  ) : (
                    <li className="font-medium text-[#475467] text-xs">No appointment note available.</li>
                  )}
                </ul>
              </div>
            ),
        )
      ) : (
        <div className="px-1.5 py-1 text-[#551FFF] text-xs">No Comments Available</div>
      )}
    </div>
  );
};

export default CartCommentsCard;
